<template>
  <div class="article-create">
    <articles-form
      v-if="!isLoading"
      :data="article"
      :channels="channels"
    />
    <div
      v-else
      class="article-create__loader"
    >
      <loading-icon
        :loading="isLoading"
        loading-class="text-center vertical-middle"
      />
    </div>
  </div>
</template>

<script>
import ArticlesForm from './form/Form'
import {mapActions} from 'vuex'

export default {
  name: 'CreateArticle',

  components: {
    ArticlesForm,
  },

  data () {
    return {
      article: null,
      channels: [],
      isLoading: true,
    }
  },

  created () {
    this.getData()
  },

  methods: {
    ...mapActions('channels', [
      'findChannel'
    ]),
    async getData () {
      const {draftId} = this.$route.params
      const {data: draftData} = await this.$http.get(`/articles/drafts/${draftId}`)
      const {id, ...article} = {...draftData.latest_revision}

      if (!article.teaser_text) {
        article.teaser_text = ''
      }

      if (!article.analysts) {
        article.analysts = []
      } else if (article.analysts.length > 0) {
        article.analyst = article.analysts[0]
      }

      if (!article.tags) {
        article.tags = []
      }

      article.channel = article.channel_content_type.channel
      article.channelId = article.channel_content_type.channel.id

      // id -> revision_id
      article.revision_id = id

      this.article = article

      this.isLoading = false
    },
  },
}
</script>

<style lang="scss">
</style>

